import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// Utils
import { formatThousandSeparator } from '../../utils/formatThousandSeparator';
// Style
import './SummarySearch.css';
// Translate
import { useTranslation } from 'react-i18next';

const SummarySearch = ({ total = 0, term = '' }) => {
  const { pathname } = useLocation();
  const currentlyRoute = pathname.replace('/', '');
  const { t } = useTranslation();
  const { searchType, queryFetched, queryAdvancedFetched } = useSelector(
    (state) => state.library
  );
  if (queryFetched || queryAdvancedFetched) {
    return (
      <div className='summarySearch'>
        <h3 className='summarySearchQuery'>
          {t('Searched term')}:{' '}
          {term
            ? term
            : currentlyRoute === 'articles'
            ? searchType === 'simple'
              ? queryFetched
              : queryAdvancedFetched
            : queryFetched}
        </h3>
        <p className='summarySearchTotal'>
          {formatThousandSeparator(total)} {t('results')}
        </p>
      </div>
    );
  } else {
    return null;
  }
};

export default SummarySearch;
